import PressableIcon from '@ui/buttons/PressableIcon'
import { View } from 'react-native'
import cn from '@ui/utils/cn'
import { topbar } from '@ui/theme/values'
import AppConfig from 'config'
import { useStagesStore } from 'hooks/useStagesStore'
import { Preset, presets, Stage } from '../types'

export const ENABLE_GUIDELINES = false // DEV: enable guidelines

export const guidelines = AppConfig.isDev ? ENABLE_GUIDELINES : false

export const GuideLine = ({ className }: { className?: string }) => (
  <View className="absolute inset-0 flex h-full w-full flex-col items-center justify-center">
    <View className={cn('h-full w-1 bg-red-500', className)} />
  </View>
)

export const BaseTest = () => {
  const { active, list, preset, setStage } = useStagesStore((state) => state)

  const index = list.findIndex((stage) => stage === active)
  const total = list.length

  const decrement = () => {
    const newIndex = index > 0 ? index - 1 : total - 1
    setStage(list[newIndex])
  }

  const increment = () => {
    const newIndex = index < total - 1 ? index + 1 : 0
    setStage(list[newIndex])
  }

  const switchPreset = () => {
    const presetList = Object.keys(presets) as Preset[]
    const currentIndex = presetList.findIndex((p) => p === preset)
    const newIndex = currentIndex < presetList.length - 1 ? currentIndex + 1 : 0
    const newPreset = presetList[newIndex]
    const newStage = presets[newPreset][0] as Stage
    setStage(newStage)
  }

  if (!guidelines) {
    return null
  }

  return (
    <View
      className="absolute left-0 w-full flex-row items-center justify-center gap-4"
      style={{ top: topbar.height }}
    >
      <PressableIcon name="minus" onPress={() => decrement()} />
      <PressableIcon name="plus" onPress={() => increment()} />
      <PressableIcon name="reload" onPress={() => switchPreset()} />
    </View>
  )
}

export const Test = () => {
  if (!guidelines) {
    return null
  }

  return <BaseTest />
}

export default Test
